const LocationIc = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_102_7)">
        <path
          d="M48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48C39.0457 48 48 39.0457 48 28Z"
          fill="white"
        />
        <path
          d="M18 25.3531L36 21C33.6454 26.2971 31.2925 31.5941 28.9379 36.8912C28.0348 34.6345 27.1336 32.3778 26.2306 30.1193L18 25.3548V25.3531Z"
          fill="#223158"
          stroke="#223158"
          stroke-width="2.5"
          stroke-miterlimit="10"
        />
        <path
          d="M36 21L25.6196 29.7631"
          stroke="#223158"
          stroke-width="2.5"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_102_7"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_102_7"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_102_7"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LocationIc;
